export default "__VITE_ASSET__DuOhOj2C__"